<template>
  <v-dialog v-model="dialog" persistent max-width="30%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{ labelBtn != "Salvar" ? "Editar Grupo Empresa" : "Cadastrar " }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col v-if="labelBtn == 'Salvar'">
              <v-text-field
                label="ID"
                v-model="form.id_grupo_empresa"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field
                label="Grupo Empresa"
                v-model="form.grupo_empresa"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col v-if="labelBtn == 'Salvar'">
              <v-text-field
                label="Descrição"
                v-model="form.descricao"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="labelBtn != 'Salvar' ? editar() : cadastrar()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/inputRules";
import sistema from "@/services/http/sistemaService";
export default {
  name: "ModalGrupoEmpresa",

  mixins: [rules],
  components: {},

  props: {
    dialog: {
      type: Boolean
    },

    labelBtn: {
      type: String
    },

    empresasGrupo: {
      type: Object
    }
  },

  data() {
    return {
      form: {}
    };
  },

  watch: {
    empresasGrupo() {
      if (this.empresasGrupo) {
        this.form = this.empresasGrupo;
      }
    }
  },

  methods: {
    async cadastrar() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .empresasGrupo()
          .store(this.form, {
            notification: true,
            message: "Grupo Empresa cadastrada com sucesso!"
          }),
          this.close();
      }
    },

    async editar() {
      const validateStatus = this.$refs.form.validate();
      if (validateStatus) {
        await sistema()
          .empresasGrupo(this.form.id_grupo_empresa)
          .update(this.form, {
            notification: true,
            message: "Grupo Empresa editado com sucesso!"
          }),
          this.close();
      }
    },

    close() {
      this.$emit("close");
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
